export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || "https://api.videomagic.app";
export const BASE_API_CLIENT_ID = process.env.REACT_APP_BASE_API_CLIENT_ID || "default_client_id";
export const BASE_API_CLIENT_SECRET = process.env.REACT_APP_BASE_API_CLIENT_SECRET || "default_client_secret";

export const BASE_APP_URL = `${window.location.protocol}//${window.location.host}`;